import {extendsAPIServices} from "./APIServices"
import getEnv from "../../helpers/common/getEnv"
import {DELETE, GET, POST} from "../../constants/HTTPConstants"

const baseAdminAPI = getEnv('baseFbResourceAPI')
const api = extendsAPIServices(baseAdminAPI)

export const _getListKeywords = (page = 1, limit) => {
    return api.makeAuthRequest({
        method: GET,
        url: '/keywords',
        params: {
            page,
            limit,
        },
    })
}

export const _addNewKeyword = (term = '') => {
    return api.makeAuthRequest({
        method: POST,
        url: '/keywords',
        data: {
            term
        }
    })
}

export const _changeKeywordStatus = (id, status = '') => {
    return api.makeAuthRequest({
        method: POST,
        url: `/keywords/${id}`,
        data: {
            status
        }
    })
}

export const _removeKeyword = (keywordId) => {
    return api.makeAuthRequest({
        method: DELETE,
        url: `/keywords/${keywordId}`,
    })
}

export const _countResultsToday = keywordId => {
    return api.makeAuthRequest({
        method: GET,
        url: `/keywords/${keywordId}/count-results`,
    })
}



// WEBPACK FOOTER //
// ./src/services/apis/KeywordServices.js